// extracted by mini-css-extract-plugin
export default {"instructionsCard":"adminApproval_instructionsCard__Kii9d"};